import images from '../../images';

const skillDetails = [
    {
        img: images.reactImg,
        skill: 'REACT',
        desc: 'Pretty new to this but climbing up the ladder.',
        usage: 'Using'
    },
    {
        img: images.jsImg,
        skill: 'JAVASCRIPT',
        desc: 'Have use it for over a year but got into some depth recently.',
        usage: 'Using'
    },
    {
        img: images.pythonImg,
        skill: 'PYTHON',
        desc: 'One of the first few languages I enjoy working in.',
        usage: 'Using'
    },
    {
        img: images.htmlImg,
        skill: 'HTML5',
        desc: 'Along with React got learn more about this.',
        usage: 'Using'
    },
    {
        img: images.cssImg,
        skill: 'CSS',
        desc: 'Not a pro at it but tagging along.',
        usage: '1 month ago'
    },
    {
        img: images.mysqlImg,
        skill: 'MYSQL',
        desc: 'Using it for more than 2 years now and trying to switch to other backend technologies as well.',
        usage: '3 months ago'
    },
    {
        img: images.javaImg,
        skill: 'JAVA',
        desc: "It's always been my least favorite but does a lot of work. It's complicated.",
        usage: 'Using'
    },
    {
        img: images.jenkins,
        skill: 'JENKINS',
        desc: "Comparatively new to this and gradually getting a hold of it.",
        usage: 'Using'
    }
]

export default skillDetails;